<template>
    <div />
</template>
<script >
import { use } from '@fegobull/webapi';
import { isMoomoo, isNN } from '@futuweb/tool-browser';
import { defineExpose, defineProps } from 'vue-demi';
import { quickCreateModal } from '../components/Modal/create';
import { useI18n } from '../lang';
import { consoleImage } from '../poster';
import { nnShareSnapShot } from '../utils/share';
import { useShare } from './use';
import { copyText } from './utils';
const __sfc_main = {};
__sfc_main.props = ['shareConfig', 'poster', 'qrTitleImage'];
__sfc_main.setup = (__props, __ctx) => {
  const {
    useToast
  } = use;
  const Toast = useToast();
  const $t = useI18n();
  /**
   * @typedef {Object} Props
   * @property {string} shareConfig
   * @property {string} poster
   * @property {string} qrTitleImage
   */
  /**
   * @type {Props}
   */
  const props = __props;
  const {
    state
  } = useShare(props.shareConfig, props.poster);
  function copyShareUrl() {
    copyText(state.shareUrl);
    Toast.msg({
      message: $t('share.copySuccess'),
      duration: 2000
    });
  }
  function showPosterShare() {
    const {
      poster,
      shareUrl
    } = state;
    consoleImage(poster);
    console.log('showPosterShare', shareUrl);
    nnShareSnapShot(poster, {
      link: shareUrl,
      image: poster
    }, () => {
      console.log('分享成功');
    });
  }
  function showFaceToFaceShare() {
    const {
      qrCode
    } = state;
    consoleImage(props.qrTitleImage);
    consoleImage(qrCode);
    quickCreateModal(() => import('../components/QrContent/index.vue'), {
      qrcode: qrCode,
      qrTitleImage: props.qrTitleImage
    });
  }
  return Object.assign({}, {
    showShare: () => {
      if (!state.shareUrl) {
        return;
      }
      // 1.判断是否是牛牛或者moomoo客户端
      // 1.1 如果是牛牛客户端唤起海报分享
      // 1.2 如果不是牛牛客户端,复制链接,提示复制链接成功
      if (isNN() || isMoomoo()) {
        if (state.poster) {
          showPosterShare(state.poster);
        } else {
          copyShareUrl();
        }
      } else {
        copyShareUrl();
      }
    },
    showFaceToFaceShare: () => {
      if (!state.qrCode || !props.qrTitleImage) {
        return;
      }
      showFaceToFaceShare();
    }
  });
};
export default __sfc_main;
</script>

<style lang="less" scoped>
div {
    display: none;
}
</style>
